import { localize } from "client_legacy/ndaw/culture";
import { upperCaseFirstCharacter } from "client/Misc/utils";
import { AppointmentKind, ZermeloAppointment } from "client/Api/Workspace/LiveInformation/Zermelo/zermeloLiveInformation";

export enum ScheduleKind {
	Day = 0,
	Week = 1
}

export function getTitle(
	appointment: ZermeloAppointment,
	isTeacher: boolean
): string {
	const {
		choice,
		groups,
		subjects,
		kind
	} = appointment;

	if (choice.isSet)
	{
		if(!choice.value.hasSelected) {
			return localize("_Choice") + ":";
		}

		if (kind === AppointmentKind.Conflict) {
			return localize("_Multiple") + ":";
		}
	}

	if (kind === AppointmentKind.Interlude) {
		return upperCaseFirstCharacter(toStringAlpabeticallySorted(subjects));
	}

	if (shouldShowGroupsInTitle(
		appointment,
		isTeacher)
	) {
		return toStringAlpabeticallySorted(groups);
	} else {
		return toStringAlpabeticallySorted(subjects).toUpperCase();
	}
}


export function getSubtitle(
	appointment: ZermeloAppointment,
	isTeacher: boolean,
	useShortVersion: boolean = false
): string {
	const {
		choice,
		subjects,
		locations,
		teachers,
		kind
	} = appointment;

	if (choice.isSet) {
		if (!choice.value.hasSelected || kind === AppointmentKind.Conflict) {
			return toStringAlpabeticallySorted(subjects).toUpperCase();
		}
	}

	let result: string = toStringAlpabeticallySorted(locations);

	if (!useShortVersion) {
		const secondPart: string = isTeacher
			? shouldShowGroupsInTitle(appointment, isTeacher)
				? toStringAlpabeticallySorted(subjects).toUpperCase()
				: ""
			: toStringAlpabeticallySorted(teachers).toUpperCase();

		if (secondPart) {
			if (result.length > 0) {
				result += " | ";
			}
			result += `${secondPart}`;
		}
	}

	return result;
}

function shouldShowGroupsInTitle(
	appointment: ZermeloAppointment,
	isTeacher: boolean
): boolean {
	if (isTeacher === false) {
		return false;
	}

	const {
		groups
	} = appointment;

	return groups.length > 0;
}

export function toStringAlpabeticallySorted(entries: string[]): string {
	return [...entries].sort()
		.join(", ");
}